import { getDisciplineDisplayName } from '@features/instructors/utils/discipline.utils';
import * as React from 'react';

import type { DisciplineItemProps } from './DisciplineItem.types';

import { getIcon } from '../../InstructorDetailPanel.utils';
import { DisciplineAction } from '../discipline-action/DisciplineAction';
import styles from '../instructor-detail-panel-content/InstructorDetailPanelContent.module.css';

const DisciplineItem = React.memo(
  ({
    discipline,
    programId,
    canEdit,
    isAnyPending,
    pendingAuthorizationId,
    uploadedCaseIds,
    onRevokeOpen,
    onDisciplineAction,
  }: Readonly<DisciplineItemProps>): React.ReactElement => {
    const handleClick = React.useCallback((): void => {
      if (discipline.state === 'Approved') {
        onRevokeOpen(discipline, programId);
      } else {
        onDisciplineAction(discipline, programId);
      }
    }, [discipline, programId, onRevokeOpen, onDisciplineAction]);

    const isUploadTransitioning =
      uploadedCaseIds.has(discipline.caseId) &&
      discipline.state === 'PendingApprovalLetter';

    return (
      <div className={styles.programDiscipline} data-testid="discipline-item">
        {getIcon(discipline.state)}
        <div className={styles.programDisciplineDetails}>
          <p className={`${styles.programDisciplineTitle} body-02`}>
            {getDisciplineDisplayName(discipline.name)}
          </p>
          <DisciplineAction
            state={discipline.state}
            canEdit={canEdit}
            onClick={handleClick}
            disabled={isAnyPending || isUploadTransitioning}
            isLoading={
              pendingAuthorizationId === discipline.authorizationId ||
              isUploadTransitioning
            }
          />
        </div>
      </div>
    );
  }
);

DisciplineItem.displayName = 'DisciplineItem';
export { DisciplineItem };
